import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../api/apiService";
import { API_ENDPOINTS } from "../../../constants/apiEndpoints";

export const getUserWorkoutPlansAction = createAsyncThunk(
  "workoutPlans/getUserWorkoutPlans",
  async (uid, thunkAPI) => {
    try {
      const response = await apiService.get(
        API_ENDPOINTS.WORKOUT_PLANS.GET_USER_PLANS(uid)
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);
